import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacySummaryChange, HttpResponse } from "@/types";

export function useGetCandidacySummaryChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacy_summary_changes",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_summary_changes`;
      const res = await guacHttpClient.get<
        CandidacySummaryChange[],
        HttpResponse<CandidacySummaryChange[]>
      >(path);
      return res.data;
    },
  });
}
